var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app-bar', {
    attrs: {
      "clipped-left": _vm.$vuetify.breakpoint.lgAndUp,
      "app": "",
      "color": _vm.color,
      "dark": "",
      "dense": ""
    }
  }, [_c('v-app-bar-nav-icon', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('input', !_vm.value);
      }
    }
  }), _c('v-toolbar-title', {
    staticClass: "tit tit--xs"
  }, [_vm._v("ebook 관리자")]), false ? _c('v-text-field', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "flat": "",
      "solo-inverted": "",
      "hide-details": "",
      "prepend-inner-icon": "mdi-magnify",
      "label": "Search"
    }
  }) : _vm._e(), _c('v-spacer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }